var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"widgetContainer"},[_c('Row',{staticClass:"widget-container"},[_c('i-col',{attrs:{"lg":24,"md":24,"sm":24,"xs":24}},[_c('LeadProcessed')],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-792b4ca0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_LeadsProcessed/LeadsProcessed.vue
// module id = null
// module chunks = 